export default __webpack_public_path__ + "static/media/DSC_7721.1a5655ad.jpg";